import ProfessionsModelBase from '../_generated/modelBases/professions-model-base';

export default class ProfessionsModel extends ProfessionsModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
